var path= window.location.hostname
var fem = path.includes("medship")
//const API_URL = fem ? "https://portal.femmegen.health/api/v1": "https://portal.medship.health/api/v1";
const API_URL =  "https://test.portal.medship.health/api/v1";

export default {
      API_URL,
};
